import { useTranslation } from 'react-i18next';
import { Icon } from '..';
import Button from '../Button';
import { Tag } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';

import styles from './ModalDownload.module.scss';
import { ApisEnumLabel, getIconApi, getGifApi } from 'Data/enums/Apis';

type DownloadModalProps = {
  platform: number;
  urlFolder?: string;
  hasFolder?: boolean;
  onTrackDownloadMultiple?: () => void;
};

const Content = ({
  platform,
  urlFolder,
  hasFolder,
  onTrackDownloadMultiple
}: DownloadModalProps) => {
  const { t } = useTranslation(['sharedModals', 'common']);
  const dispatch = useDispatch();

  return (
    <div className={styles['Wrapper']}>
      <div className={styles['header']}>
        <div className={styles['iconBox']}>
          <Icon
            icon="cancelar"
            customSize={12}
            color="branco"
            onClick={() =>
              dispatch(
                ListagemArquivosActions.setShowModalDownloadMultipleFiles({
                  isVisible: false
                })
              )
            }
          />
        </div>
        <div className={styles['imageBox']}>
          <img
            src={getGifApi(platform)}
            alt={`Gif de exemplo para download na plataforma do ${ApisEnumLabel[platform]}`}
          />
        </div>
      </div>
      <div className={styles['content']}>
        <Tag color="#3547C8" className={styles['tag']}>
          <Icon icon={getIconApi(platform)} color="branco" customSize={12} />
          {t('sharedModals:modalDownload.externalFunction')}
        </Tag>

        <h4 className={styles['title']}>
          {hasFolder
            ? t('sharedModals:modalDownload.folderDownload')
            : t('sharedModals:modalDownload.multipleDownload')
          }
        </h4>
        <p className={styles['description']}>
          {hasFolder
            ? t('sharedModals:modalDownload.folderDesc', { platform: ApisEnumLabel[platform] })
            : t('sharedModals:modalDownload.filesDesc', { platform: ApisEnumLabel[platform] })
          }
        </p>
      </div>

      <Footer
        platform={platform}
        urlFolder={urlFolder}
        onTrackDownloadMultiple={onTrackDownloadMultiple}
      />
    </div>
  );
};

const Footer = ({ platform, urlFolder, onTrackDownloadMultiple }: DownloadModalProps) => {
  const { t } = useTranslation(['sharedModals', 'common']);
  return (
    <div className={styles['Footer']}>
      <div className={styles['link']}>
        <a
          href="https://www.maletadoengenheiro.com.br/blog"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('common:learnMore')}
        </a>
      </div>
      <Button
        type="primary"
        onClick={onTrackDownloadMultiple ? onTrackDownloadMultiple : undefined}
      >
        <a
          className={styles['buttonLink']}
          href={urlFolder}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('sharedModals:modalDownload.openPlatform', { platform: ApisEnumLabel[platform] })}
        </a>
      </Button>
    </div>
  );
};

const DownloadModal = ({
  platform,
  urlFolder,
  onTrackDownloadMultiple
}: DownloadModalProps) => {
  const visible = useSelector(
    (state: IGlobalReducerState) => state.listagemArquivos.showModalDownloadMultipleFiles
  );
  const hasFolder = useSelector(
    (state: IGlobalReducerState) => state.listagemArquivos.hasFolderModalDownload
  );

  if (!visible) {
    return null;
  }

  return (
    <div className={styles['Modal']}>
      <Content
        platform={platform}
        urlFolder={urlFolder}
        onTrackDownloadMultiple={onTrackDownloadMultiple}
        hasFolder={hasFolder}
      />
    </div>
  );
};

export default DownloadModal;
